export default __webpack_public_path__ + "static/media/TimerIcon.61aef1a9.svg";